import { DsLibMainMenuListItemInterface } from '../interfaces/ds-lib-main-menu-list-item.interface';

/**
 * Item displayed inside the dropdown select.
 */
export class DsLibMainMenuListItem {
  id: number;

  name: string;

  /**
   * Creates an instance of DsLibMainMenuListItem.
   *
   * @param json the item id
   */
  constructor(json: DsLibMainMenuListItemInterface) {
    this.id = json.id;
    this.name = json.name;
  }
}
